/* Injects liquid-sweep wave layers into buttons when enabled in theme
   settings (Buttons → Hover animation). Styles live in base.css; wave colors
   resolve in theme-styles-variables.liquid. No JS / reduced motion ⇒ buttons
   keep the classic hover.

   Section hydration (morph) strips injected spans and data attributes shortly
   after load, so enhancement must be idempotent and re-run on any mutation —
   including removals — rather than only on added nodes. */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const config = document.currentScript.dataset;
  const selectors = [];
  if (config.primary === 'liquid') {
    selectors.push('.button:not(.button-secondary):not(.button-unstyled):not([class*="shopify-payment"])');
  }
  if (config.secondary === 'liquid') {
    // Never the skip link: it is hidden via position: absolute, which the
    // liquid position: relative would undo, dropping it back into layout.
    selectors.push('.button-secondary:not(.button-unstyled):not(.skip-to-content-link)');
  }
  const liquidSelector = selectors.join(', ');
  const rampTertiary = config.tertiary === 'ramp';

  const addWaves = (button) => {
    const waves = button.querySelectorAll('.btn-wave');
    if (waves.length === 4 && button.hasAttribute('data-liquid')) return;
    for (const wave of waves) wave.remove();
    button.setAttribute('data-liquid', '');
    for (let i = 1; i <= 4; i++) {
      const wave = document.createElement('span');
      wave.className = `btn-wave btn-wave--${i}`;
      wave.setAttribute('aria-hidden', 'true');
      button.append(wave);
    }
  };

  const enhance = () => {
    if (liquidSelector) {
      for (const button of document.querySelectorAll(liquidSelector)) addWaves(button);
    }
    if (rampTertiary) {
      for (const link of document.querySelectorAll('.button-tertiary')) {
        if (!link.hasAttribute('data-ramp')) link.setAttribute('data-ramp', '');
      }
    }
  };

  const start = () => {
    enhance();
    let scheduled = false;
    /* Guards in addWaves/enhance make re-scans converge, so our own
       mutations can't loop the observer. setTimeout rather than rAF —
       rAF stalls in background tabs and would strand the flag. */
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      setTimeout(() => {
        scheduled = false;
        enhance();
      }, 24);
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-liquid', 'data-ramp'],
    });
    window.addEventListener('load', enhance);
    document.addEventListener('shopify:section:load', enhance);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
